import { render } from "./StoreCitation.vue?vue&type=template&id=6730474e"
import script from "./StoreCitation.vue?vue&type=script&lang=js"
export * from "./StoreCitation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
